import React from "react";
import clsx from "clsx";

import { ReactComponent as IconGoodOn } from "../../../assets/images/AnswerList/icon_good_on.svg";
import { ReactComponent as IconGoodOff } from "../../../assets/images/AnswerList/icon_good_off.svg";
import { ReactComponent as IconCommentOn } from "../../../assets/images/AnswerList/icon_comment_on.svg";
import { ReactComponent as IconCommentOff } from "../../../assets/images/AnswerList/icon_comment_off.svg";
import { IAnswer } from "../../../state";
import OneAnswerContents from "../../OneAnswerContents";
import FormReply from "../../../organisms/teacher/FormReply";
import FormComment from "../../../organisms/student/FormComment";

import styles from "./OneAnswerBox.module.scss";

export type OneAnswerBoxProps = {
  calling: boolean;
  currentTeacherID: number;
  name_opened: boolean;
  answer: IAnswer;
  isGroupAnswer?: boolean;
  isHighlighted?: boolean;
  handleLike: (answer_id: number) => void;
  handleComment: (
    content: string,
    answer_id: number,
    comment_id?: number,
  ) => void;
  handleToggleComment: (
    answer_id: number,
    comment_id: number,
    is_hidden: boolean,
  ) => void;
  handleDeleteComment: (answer_id: number, comment_id: number) => void;
};

export const OneAnswerBox: React.FC<OneAnswerBoxProps> = ({
  calling,
  currentTeacherID,
  name_opened,
  answer,
  isGroupAnswer = false,
  isHighlighted = false,
  handleLike,
  handleComment,
  handleToggleComment,
  handleDeleteComment,
}) => {
  const [isCommentOpen, setIsCommentOpen] = React.useState(false);

  const handleCommentWithKeepOpen = React.useCallback(
    (content: string, answer_id: number, comment_id?: number) => {
      setIsCommentOpen(true);
      handleComment(content, answer_id, comment_id);
    },
    [handleComment],
  );

  const answerId = React.useMemo(
    () => (isGroupAnswer ? "groupAnswer" : "answer") + answer.id.toString(),
    [answer.id, isGroupAnswer],
  );

  const commentId = React.useMemo(
    () =>
      (isGroupAnswer ? "groupAnswerComment" : "answerComment") +
      answer.id.toString(),
    [answer.id, isGroupAnswer],
  );
  return (
    <div
      className={clsx(styles.body, isHighlighted && styles.highlighted)}
      key={answer.id}
    >
      {answer.contents && <OneAnswerContents contents={answer.contents} />}
      <div className={styles.header}>
        <button
          className={styles.button}
          disabled={calling}
          onClick={() => handleLike(answer.id)}
        >
          {answer.is_like ? <IconGoodOn /> : <IconGoodOff />}
          <span className={styles.text}>いいね：{answer.like_num}人</span>
        </button>
        <button
          className={styles.button}
          onClick={() => setIsCommentOpen(!isCommentOpen)}
          aria-expanded={isCommentOpen}
        >
          {answer.comments.length > 0 ? <IconCommentOn /> : <IconCommentOff />}
          <span className={styles.text}>
            コメント：{answer.comments.length}件
          </span>
        </button>
      </div>
      <div
        className={isCommentOpen ? "collapse show" : "collapse"}
        id={`from-${answer.id}`}
      >
        <div className={styles.comment}>
          {answer.comments.length > 0 && (
            <div className={styles.commentList} id={commentId}>
              {answer.comments.map(cmt => (
                <FormReply
                  key={cmt.id}
                  comment={cmt}
                  answerId={answer.id}
                  name_opened={name_opened}
                  calling={calling}
                  currentTeacherID={currentTeacherID}
                  handleComment={handleCommentWithKeepOpen}
                  handleToggleComment={handleToggleComment}
                  handleDeleteComment={handleDeleteComment}
                />
              ))}
            </div>
          )}
          <div className={styles.fromComment} id={answerId}>
            <FormComment
              answer={answer}
              replyAnswer={handleCommentWithKeepOpen}
              calling={calling}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OneAnswerBox;
